import { BaseError } from "errors/BaseError";

export default class HttpRequestError extends Error implements BaseError {
  public statusCode: number;

  constructor(m: string, statusCode: number) {
    super(m);
    this.statusCode = statusCode;
  }

  needAlert(): boolean {
    return true;
  }

  getMessage(): string {
    return this.getErrorDefaultText()
      ? this.getErrorDefaultText()
      : this.message;
  }

  private getErrorDefaultText() {
    switch (this.statusCode) {
      case 401:
        return "認証エラーです。権限がありません。";
      case 402:
        // ★未払いで 止まっている時★（Payment Required）
        //
        // 此処が 無いと default に 落ち、止められたお客様に
        // 「ブラウザのキャッシュをクリアしてください」と 出ていた（2026-08-13 実測）。
        // 理由も 払い方も 伝わらず、リロードを 繰り返させることになる。
        //
        // ★既定文を 返すと サーバーの 文言が 捨てられる★（getMessage は 既定文を 優先する）。
        // ゆえに サーバーが 文言を 送っていれば 空を 返し、そのまま 出す。
        return this.message
          ? ""
          : "お支払いが確認できないため、ご利用を一時停止しております。設定 → お支払い からカードをご登録ください。";
      case 404:
        return "お探しのページが見つかりません。";
      case 500:
        return "システムエラーが発生しました。";
      case 400:
      default:
        return "ブラウザ上のデータが一部古い可能性があります。ブラウザをリロードまたキャッシュをクリアしてください。";
    }
  }
}
